import API from "../../api";
let token = localStorage.getItem("token");

export const getAquaaAccountsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaAgentsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaChannelsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaLanguagesDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaLocationsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaValidFromDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaMarketGroupDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaAWSDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getEvaluationFormDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateEvaluationFormDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getSavedEvaluationsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getSubmittedEvaluationsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getSavedEvaluationFormDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaNonASDAccountsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaNonASDChannelsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaNonASDLocationsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaNonASDLanguagesDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaNonASDAgentsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAdditionalReciepientsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getNonASDEvaluationFormDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAgentEvaluationsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaAdminAccountsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaAdminAccountsTableDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaAdminChannelsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaAdminContactTypeTableDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateAquaaAdminAccountsDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateAquaaAdminContactTypeDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaQuestionAssessmentsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaAdminQuestionsTableDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateAquaaAdminQuestionsDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateAquaaAcknowledgementDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaMappingAccountsService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

    export const getAquaaMappingContacttypeFormsService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

    export const getAquaaMappingCountriesService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

    export const getAquaaMappingSectionsService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

    export const getAquaaMappingQuestionsService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaMappingParameterTypeService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateAquaaMappingDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaEvaluationsDeleteService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateAquaaEvaluationsDeleteService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaValidateTicketNoService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaIcedAgentsService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaIcedAccountsService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaIcedTableDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaIcedL1CategoryService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaIcedL2CategoryService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateAquaaIcedDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAquaaIcedEvaluationsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAccountEvaluatorAccountsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAccountEvaluatorEvaluatorsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAccountEvaluatorTableDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateAccountEvaluatorMappingDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateNewEvaluatorDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getAccountEvaluatorUsersDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getIcedReportsAccountsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getIcedMasterDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateIcedDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getIcedTableDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateSubmittedCommentsDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getRecommendationsTableDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateTrainingAssignmentDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateTrainingCommentsDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getTrainerTableDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateAgentTrainingCommentsDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getRecommendationsDropdownDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateEFMissingDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };


  